import * as React from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Platform,
} from "react-native";
import CustomIcon from "../components/CustomIcon";
// import { enableTransactionFilterModal } from "../redux/actions/UIStateActions"; a part of cleaner code
import { useNavigation } from "@react-navigation/native";

export default function OpenFilter() {
  const navigation = useNavigation();
  return Platform.OS != "web" ? (
    <View style={styles.makeRow}></View>
    /* temp removal from  app as well
    <TouchableOpacity
      style={styles.iconContainer}
      //onPress={() => enableTransactionFilterModal()}
      onPress={() => navigation.navigate("SpendingInsightsFilter")}
    >
      <View style={styles.makeRow}>
        <View style={styles.centerVert}>
          <Text style={styles.filterText}>FILTER</Text>
        </View>
        <View style={styles.centerVert}>
          <CustomIcon name="icon-settings" size={20} color="rgba(0,0,0,1)" />
        </View>
      </View>
    </TouchableOpacity>
    */
  ) : (
    /*
    <TouchableOpacity
      style={styles.iconContainer}
      onPress={() => navigation.navigate("SpendingInsightsFilter")}
    >
      <View style={styles.makeRow}>
        <View style={styles.centerVert}>
          <Text style={styles.filterText}>FILTER</Text>
        </View>
        <View style={styles.centerVert}>
          <CustomIcon name="icon-settings" size={20} color="rgba(0,0,0,1)" />
        </View>
      </View>
    </TouchableOpacity>
    */
    <View style={styles.makeRow}></View>
  );
}
const styles = StyleSheet.create({
  makeRow: {
    flexDirection: "row",
    paddingRight: 5,
  },

  centerVert: {
    justifyContent: "center",
  },

  iconContainer: {
    paddingRight: 15,
    paddingRight: 15,
  },

  filterText: {
    fontFamily: "montserrat-regular",
    fontSize: 8,
    textAlign: "right",
    paddingRight: 8,
    color: "#000",
  },
});
